/* eslint-disable max-len, react/jsx-key */

import React from 'react'
import { FormattedMessage } from 'react-intl'

export const SLIDES_TEXTS = {
    SLIDE_1: {
        title: (
            <FormattedMessage
                id='migration_screen.reserves_update.title'
                defaultMessage='Обновление резервов'
            />
        ),
        descriptions: [
            <FormattedMessage
                id='migration_screen.reserves_update.description_1'
                defaultMessage='Артобстрел теперь наносит стабильный периодический урон. Место, куда вызван артобстрел, будет показано заранее.'
            />,
            <FormattedMessage
                id='migration_screen.reserves_update.description_2'
                defaultMessage='Резерв «Авиаудар» заменён на «Воодушевление». Игрок, активировавший этот резерв, и союзники в радиусе действия резерва получают бонус к основным специальностям и всем умениям экипажей.'
            />,
            <FormattedMessage
                id='migration_screen.reserves_update.description_3'
                defaultMessage='«Артобстрел» и «Воодушевление» можно брать в бой одновременно.'
            />,
        ],
    },
    SLIDE_2: {
        title: (
            <FormattedMessage
                id='migration_screen.buildings_update.title'
                defaultMessage='Обновление строений'
            />
        ),
        descriptions: [
            <FormattedMessage
                id='migration_screen.buildings_update.description_1'
                defaultMessage='Строение «Полк бомбардировочной авиации» заменено на «Служба тыла», в котором можно подготавливать резерв «Воодушевление».'
            />,
        ],
    },
    SLIDE_3: {
        title: (
            <FormattedMessage
                id='migration_screen.compensation.title'
                defaultMessage='Компенсация'
            />
        ),
        descriptions: [
            <FormattedMessage
                id='migration_screen.compensation.description_1'
                defaultMessage='У кланов были убраны уже подготовленные резервы «Артобстрел» и «Авиаудар». Затраченный на их подготовку промресурс возвращён.'
            />,
            <FormattedMessage
                id='migration_screen.compensation.description_2'
                defaultMessage='Количество возвращённого промресурса можно просмотреть в Укрепрайоне на экране «Журнал», вкладка «Промресурс».'
            />,
        ],
    },
}



// WEBPACK FOOTER //
// ./containers/MigrationScreen/translations.jsx